import {OnDestroy} from '@angular/core';
import * as moment from 'moment';
import {Subscription} from 'rxjs/Subscription';
import {UserService} from '../services/user.service';
import {UnpaidLeaveMonth, UnpaidLeavePreview} from '../content-page/common/vacation/vacation.models';
import {UNPAID_EMPTY, UNPAID_ERROR_KEYS, UNPAID_PREVIEW_ERROR} from '../content-page/common/vacation/unpaid-leave.constants';
import {ReportDatepickerVacationView} from './report-datepicker.types';
import {VacationTypes} from './vacation-Types';
import {CALENDAR_MONTH_OFFSET, DATE_FORMAT} from './report-datepicker.constants';

const SIGNATURE_SEPARATOR = '/';
const FROM_INDEX = 0;
const TO_INDEX = 1;
const INVALID_DATE_KEY = 'VACATION_ERROR_DATE_INVALID';

export class UnpaidLeavePreviewState implements OnDestroy {
  result: UnpaidLeavePreview;
  loading = false;
  errorKey = UNPAID_EMPTY;
  rejectionKey = UNPAID_EMPTY;
  readonly reasonKeys = UNPAID_ERROR_KEYS;
  readonly trackMonth = (_index: number, month: UnpaidLeaveMonth): string => month.month;
  readonly trackReason = (_index: number, reason: string): string => reason;
  private signature = UNPAID_EMPTY;
  private request: Subscription;

  constructor(private users: UserService) {}

  refresh(view: ReportDatepickerVacationView): void {
    this.ngOnDestroy();
    this.result = null;
    this.errorKey = this.rejectionKey = UNPAID_EMPTY;
    this.signature = this.signatureFor(view);
    if (!this.signature) {
      this.errorKey = view.type === VacationTypes.UNPAID_LEAVE ? INVALID_DATE_KEY : UNPAID_EMPTY;
      return;
    }
    const dates = this.signature.split(SIGNATURE_SEPARATOR);
    const signature = this.signature;
    this.loading = true;
    this.request = this.users.getUnpaidLeavePreview(dates[FROM_INDEX], dates[TO_INDEX]).subscribe(
      result => this.accept(result, signature), error => this.fail(error, signature));
  }

  ready(view: ReportDatepickerVacationView): boolean {
    return !!this.result && !this.loading && !this.errorKey &&
      this.signature === this.signatureFor(view) && this.result.canRequest;
  }

  reject(view: ReportDatepickerVacationView, code: string): boolean {
    if (view.type !== VacationTypes.UNPAID_LEAVE || !UNPAID_ERROR_KEYS[code]) { return false; }
    this.refresh(view);
    this.rejectionKey = UNPAID_ERROR_KEYS[code];
    return true;
  }

  ngOnDestroy(): void {
    this.signature = UNPAID_EMPTY;
    this.loading = false;
    if (this.request) { this.request.unsubscribe(); }
  }

  private signatureFor(view: ReportDatepickerVacationView): string {
    if (view.type !== VacationTypes.UNPAID_LEAVE || !view.from || !view.to) { return UNPAID_EMPTY; }
    const from = moment([view.from.year, view.from.month - CALENDAR_MONTH_OFFSET, view.from.day]);
    const to = moment([view.to.year, view.to.month - CALENDAR_MONTH_OFFSET, view.to.day]);
    return from.isValid() && to.isValid() && !to.isBefore(from)
      ? from.format(DATE_FORMAT) + SIGNATURE_SEPARATOR + to.format(DATE_FORMAT) : UNPAID_EMPTY;
  }

  private accept(result: UnpaidLeavePreview, signature: string): void {
    if (signature !== this.signature) { return; }
    this.loading = false;
    this.result = result;
  }

  private fail(error: {error?: {errorCode?: string}}, signature: string): void {
    if (signature !== this.signature) { return; }
    this.loading = false;
    this.errorKey = error.error && UNPAID_ERROR_KEYS[error.error.errorCode] || UNPAID_PREVIEW_ERROR;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/unpaid-leave-preview.state.ts